import { createApp } from 'vue'
import App from './App.vue'
import { createMemoryHistory, createRouter } from 'vue-router'
import HomeView from './views/HomeView.vue'
import FaqView from './views/FaqView.vue'
import ServicesView from './views/ServicesView.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'


const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomeView
    },
    {
        path: '/services',
        name: 'Services',
        component: ServicesView
    },
    {
        path: '/help',
        name: 'FAQ',
        component: FaqView
    }
]

const router = createRouter({
    history: createMemoryHistory(),
    routes,
    scrollBehavior(to) {
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth'
            }
        }
        return { top: 0 }
    }
})

createApp(App).use(router, ElementPlus).mount('#app')
